export default function SubPageDot() {
  return (
    <i className="mr-4 max-md:mr-2">
      <div className="w-3 h-3 max-md:w-[6px] max-md:h-[6px] rounded-full bg-gradient-to-br from-[#FF4E83] to-[#FFBB54]" />
    </i>
  );
}
